import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';

export class FinishTelegramAccountAuthUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string, input: { code: string; password: string | null }): Promise<void> { return this.repo.finishAuth(uuid, input); }
}
